module.exports = __webpack_public_path__ + "static/media/webdesign-services-img71.61a83026.jpg";